// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo--16D6J{border-bottom:1px solid #d9d9d9;box-sizing:border-box;display:block;flex:0 0 auto;height:145px}.image--2f3OZ{left:50%;margin-left:-100px;pointer-events:none;position:absolute;top:0;width:200px;z-index:2}\n", ""]);
// Exports
exports.locals = {
	"logo": "logo--16D6J",
	"image": "image--2f3OZ"
};
module.exports = exports;
